<template>
  <Windows />
  
  <div id="app" class="login">

    <div class="loginContainer box-shadow" v-if="show == 1">
      <div>
        <h1>MIP-Förderung</h1>
      </div>
      <div v-if="error" class="redText">
        {{ error }}
      </div>
      
      <div class="loginForm">
        <h2>Anmeldung:</h2>
        <form ref="theForm" method="post" action="login" target="_top" >
          <div class="login-field">
            <label><span>Benutzername:</span></label>
            <input name="ticket" v-model="email" @keyup.enter="$refs.anmeldeButton.focus()" />
          </div>
          <div class="login-field">
            <label><span>Passwort</span></label>
            <PasswordInput name="dspf_user_id" v-model:modelValue="passwort" @keyup.enter="login" />
          </div>
        </form>
        <div>
          <button class="login-button" value="Login" @click="login" ref="anmeldeButton">Anmelden</button>
        </div>
      </div>
      <hr />
      <div class="loginToolsRow">
        <button @click="show = 2" style="margin-left: 0px;">
          Bitte hier klicken, um sich zu registrieren
        </button>
        <button @click="show = 3">
          Bitte hier klicken, um das Passwort zurückzusetzen
        </button>
      </div>
    </div>
    <Register v-if="show == 2" @done="show = 1"/>
    <ResetPassword v-if="show == 3" @done="show = 1"/>
  </div>
</template>

<script>
import { ref, computed } from "vue";

import Register from "./Registrierung.vue"
import ResetPassword from "./ResetPassword.vue"
import Windows from "vueforms/src/components/windows/Windows.vue"
import windowManager from "vueforms/src/utils/WindowManager"
import apifetch from "vueforms/src/utils/apifetch"
import { xsrfTokenParameterName, xsrfTokenValue } from "vueforms/src/utils/xsrfSynchronizerToken"
import isValidEMail from "./isValidEMail"
import PasswordInput from "vueforms/src/components/base/PasswordInput.vue"

export default {
  components: {
    Register,
    ResetPassword,
    Windows,
    PasswordInput
  },
  setup(props) {
    const show = ref(1);
    const email = ref("");
    const passwort = ref("");
    const error = ref("");
    const isInvalidEMail = computed(() => !isValidEMail(email.value));
    const theForm = ref(null);
    
    const login = () => {
      var formBody = [];
      formBody.push("ticket=" + encodeURIComponent(email.value));
      formBody.push("dspf_user_id=" + encodeURIComponent(passwort.value));
      formBody = formBody.join("&");
      const response = apifetch("login", {
        method: "POST",
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' ,
                   'Accept': 'application/json'
                 },
        body: formBody
      }).then(e => 
      e.json()
      );
      response.then(data => {
        if (!data.error) {
          theForm.value.submit();
        }
        else if (data.error == "BadCredentialsException") {
          error.value = "Ungültige Angaben";
        }
        else if (data.error == "DisabledException") {
          error.value = "Ihr Zugang ist deaktiviert. Wenden Sie sich an den Support.";
        }
        else if (data.error == "LockedException") {
          error.value = "Ihr Zugang ist gesperrt. Wenden Sie sich an den Support.";
        }
        else error.value = "Fehler bei der Anmeldung";
      }
      );
    };

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const showpw = ref(false);

    return {
      showpw,
      show,
      email,
      passwort,
      isInvalidEMail,
      error,
      login,
      theForm
    }
  }
}
</script>


<style lang="scss">
@import "../assets/variables.scss";

body {
  background: none;
}

</style>
